export default "__VITE_ASSET__CdKD2MwI__"